import { AnimalIdLink } from './animal-id-link';

export default AnimalIdLink;
